import React, { useEffect, useState } from 'react';
import { Card, Col, ListGroup, Row } from 'react-bootstrap';
import {
      CardHeader,
      CardLinks,
      CardTitle
} from '../../styles/components/common/Table';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ItemShow from '../../components/Form/ItemShow';
import { LinkButton } from '../../styles/components/common/Button';
import toast from 'react-hot-toast';
import { Loading } from '../../components/Loading';
import FormButton from '../../components/Form/Button';

const DealerRequestShow = () => {
      const { requestId } = useParams();
      const [enquiry, setEnquiry] = useState([]);
      const [loadingData, setLoadingData] = useState(false);

      const token = JSON.parse(localStorage.getItem('token'));

      const loadCategories = async () => {
            setLoadingData(true);

            await axios
                  .get(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/dealer_requests/${requestId}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setEnquiry(response.data.dealer);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoadingData(false);
      };

      useEffect(() => {
            loadCategories();
      }, []);

      const [loadingAccept, setLoadingAccept] = useState(false);
      const [loadingReject, setLoadingReject] = useState(false);

      const handleAccept = async () => {
            setLoadingAccept(true);

            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/dealer_requests/${requestId}/accept`,
                        {},
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });

            setLoadingAccept(false);
      };

      const handleReject = async () => {
            setLoadingReject(true);

            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/dealer_requests/${requestId}/reject`,
                        {},
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });

            setLoadingReject(false);
      };

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader>
                                          <CardTitle>
                                                Dealer Request Detail
                                          </CardTitle>
                                          <CardLinks>
                                                <LinkButton to="/dashboard/dealer_requests">
                                                      Back
                                                </LinkButton>
                                          </CardLinks>
                                    </CardHeader>
                                    <Card.Body>
                                          {!loadingData ? (
                                                <Row>
                                                      <Col lg={6}>
                                                            <ListGroup>
                                                                  <ItemShow
                                                                        title="Full Name"
                                                                        value={
                                                                              enquiry.name
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Company Name"
                                                                        value={
                                                                              enquiry.company_name
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="PAN No"
                                                                        value={
                                                                              enquiry.pan_no
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Phone No."
                                                                        value={
                                                                              enquiry.phone_number
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Email"
                                                                        value={
                                                                              enquiry.email
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Address"
                                                                        value={
                                                                              enquiry.address
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Date"
                                                                        value={
                                                                              enquiry.date
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Remarks"
                                                                        value={
                                                                              enquiry.remarks
                                                                        }
                                                                  />
                                                            </ListGroup>

                                                            <FormButton
                                                                  title="Reject"
                                                                  type="button"
                                                                  handleButton={
                                                                        handleReject
                                                                  }
                                                                  classes="btn-danger me-3 mt-4"
                                                                  loading={
                                                                        loadingReject
                                                                  }
                                                            />
                                                            <FormButton
                                                                  title="Accept"
                                                                  type="button"
                                                                  classes="btn-success mt-4"
                                                                  handleButton={
                                                                        handleAccept
                                                                  }
                                                                  loading={
                                                                        loadingAccept
                                                                  }
                                                            />
                                                      </Col>
                                                      {enquiry.pan_file && (
                                                            <Col lg={6}>
                                                                  <img
                                                                        src={
                                                                              enquiry.pan_file
                                                                        }
                                                                        alt=""
                                                                        className="w-100"
                                                                  />
                                                            </Col>
                                                      )}
                                                </Row>
                                          ) : (
                                                <>
                                                      <div
                                                            className="text-center d-flex align-items-center justify-content-center w-100"
                                                            style={{
                                                                  height: '30vh'
                                                            }}
                                                      >
                                                            <Loading />
                                                      </div>
                                                </>
                                          )}
                                    </Card.Body>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default DealerRequestShow;
